import React from 'react';
import TeamBadge, { pickTeamLogo } from './TeamBadge';
import { teamSideName } from './matchWidgetUtils';

const TYPE_STYLE = {
  goal: { label: 'Goal', icon: '⚽', className: 'sw-event--goal' },
  yellowcard: { label: 'YC', icon: '🟨', className: 'sw-event--yellow' },
  redcard: { label: 'RC', icon: '🟥', className: 'sw-event--red' },
  subst: { label: 'Sub', icon: '↔', className: 'sw-event--sub' },
  var: { label: 'VAR', icon: '📺', className: 'sw-event--var' },
};

function eventSummary(ev) {
  if (ev.type === 'goal') {
    return `${ev.player}${ev.assist ? ` · ${ev.assist}` : ''}`;
  }
  if (ev.type === 'subst') {
    return `${ev.player}${ev.playerOff ? ` ← ${ev.playerOff}` : ''}`;
  }
  return ev.player || ev.playerOff || '—';
}

export default function MatchEventTimeline({ match, events = [], goals = [] }) {
  const timeline = events.length ? events : goals.length ? goals : match?.events || [];

  if (!timeline.length) {
    return (
      <p className="text-center text-xs py-8 px-4" style={{ color: 'var(--sw-muted)' }}>
        No match events for this fixture yet.
      </p>
    );
  }

  return (
    <div className="px-4 pb-4">
      <ul className="sw-event-timeline">
        {timeline.map((ev, i) => {
          const style = TYPE_STYLE[ev.type] || { label: ev.type, icon: '•', className: '' };
          const team = teamSideName(match, ev.team);
          const logoUrl =
            match && (ev.team === 'home' || ev.team === 'away')
              ? pickTeamLogo(match, ev.team)
              : pickTeamLogo({ team });
          return (
            <li key={`${ev.type}-${ev.minute}-${i}`} className={`sw-event-item ${style.className}`}>
              <div className="sw-event-item__rail">
                <span className="sw-event-item__dot" />
                {i < timeline.length - 1 && <span className="sw-event-item__line" aria-hidden />}
              </div>
              <div className="sw-event-item__body">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="sw-event-item__minute tabular-nums">
                    {ev.minute ? `${ev.minute}'` : '—'}
                  </span>
                  <span className="sw-event-item__badge">
                    <span aria-hidden>{style.icon}</span> {style.label}
                  </span>
                  {ev.result && (
                    <span className="ml-auto text-xs font-mono tabular-nums" style={{ color: 'var(--sw-muted)' }}>
                      {ev.result}
                    </span>
                  )}
                </div>
                <p className="font-semibold text-sm">{eventSummary(ev)}</p>
                <p
                  className="text-[10px] mt-0.5 flex items-center gap-1.5"
                  style={{ color: 'var(--sw-muted)' }}
                >
                  <TeamBadge name={team} logoUrl={logoUrl} size={14} />
                  {team}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
